import { Accent } from "./Primitives";

export const PageIntro = ({ eyebrow, title, body, children }) => (
  <section className="pt-20 md:pt-28 pb-12 md:pb-16 border-b border-[#27272A] relative overflow-hidden">
    <div className="absolute -left-40 -top-40 w-[500px] h-[500px] bg-[#0055FF]/10 blur-[140px] pointer-events-none" />
    <div className="eb-container relative">
      {eyebrow && <p className="eb-label !text-[#00E5FF] mb-6">{eyebrow}</p>}
      <h1 className="text-4xl sm:text-5xl lg:text-7xl font-semibold tracking-[-0.04em] leading-[0.95] max-w-5xl" data-testid="page-title"><Accent text={title} /></h1>
      {body && <p className="mt-6 text-zinc-400 text-lg max-w-2xl leading-relaxed">{body}</p>}
      {children}
    </div>
  </section>
);
